<template>
  <div>
    <div class="font-14 font-weight-bold">
      <span class="color-orange-light-2 mr-2">
        {{ $t('lblWizardStep2SectionTitle.text') }}
        <span class="align-sub">* * *</span>
      </span>
      <span class="color-dark-blue">{{ $t('lblWizarStep2Title.text') }}:</span>
    </div>
    <div v-if="!isReadOnly">
      <validation-observer ref="formRef" v-slot="{}" tag="form">
        <div class="row mt-4">
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantFirstName') }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input
                v-model="model.mentorFullName"
                maxlength="250"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantWorkPosition') }}
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input
                v-model="model.mentorWorkPosition"
                maxlength="250"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantWorkPlace') }}
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input
                v-model="model.mentorWorkPlace"
                maxlength="250"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('PhoneNumber') }}:
            </div>
            <validation-provider rules="required|min:10" v-slot="{ errors }">
              <custom-input
                v-model="model.mentorTelephone"
                maxlength="20"
                mask-type="Phone"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Mobile') }}:
            </div>
            <custom-input
              v-model="model.mentorCellPhone"
              maxlength="20"
              mask-type="Phone"
            />
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Email') | capitalize }}:
            </div>
            <validation-provider rules="required|email" v-slot="{ errors }">
              <custom-input
                v-model="model.mentorEmail"
                maxlength="100"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-else class="mt-4">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="color-gray-18 font-14">
            {{ $t('ApplicantFirstName') }}:
          </div>
          <span class="color-black font-14">{{ model.mentorFullName }}</span>
        </div>
        <div class="col-12 col-md-4">
          <div class="color-gray-18 font-14">
            {{ $t('ApplicantWorkPosition') }}
          </div>
          <span class="color-black font-14">
            {{ model.mentorWorkPosition }}
          </span>
        </div>
        <div class="col-12 col-md-4">
          <div class="color-gray-18 font-14">
            {{ $t('ApplicantWorkPlace') }}
          </div>
          <span class="color-black font-14">{{ model.mentorWorkPlace }}</span>
        </div>
        <div class="col-12 col-md-4 mt-4">
          <div class="color-gray-18 font-14">{{ $t('PhoneNumber') }}:</div>
          <span class="color-black font-14">{{ model.mentorTelephone }}</span>
        </div>
        <div class="col-12 col-md-4 mt-4">
          <div class="color-gray-18 font-14">{{ $t('Mobile') }}:</div>
          <span class="color-black font-14">
            {{ model.mentorCellPhone | empty }}
          </span>
        </div>
        <div class="col-12 col-md-4 mt-4">
          <div class="color-gray-18 font-14">
            {{ $t('Email') | capitalize }}:
          </div>
          <span class="color-black font-14">{{ model.mentorEmail }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//libs
import CustomInput from 'CustomInput';

export default {
  name: 'ResponsibleInformation',
  components: {
    CustomInput,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.info || {},
    };
  },
  methods: {
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
  },
};
</script>
